export const BREADCRUMB_PREFERRED_ALIAS_SET = 'BREADCRUMB_PREFERRED_ALIAS_SET';
export const BREADCRUMB_PREFERRED_ALIAS_CLEAR = 'BREADCRUMB_PREFERRED_ALIAS_CLEAR';
